import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseHref } from "service/api";

type AssetFeesResponse = {
  rates?: {
    max: number;
    mid: number;
    min: number;
  };
  newArchNetworkFeePrice: {
    min: {
      min: number;
      value: number;
      usd: number;
      eur: number;
    };
    mid: {
      mid: number;
      value: number;
      usd: number;
      eur: number;
    };
    max: {
      max: number;
      value: number;
      usd: number;
      eur: number;
    };
  };
  result: boolean;
};
type SendFeeInfoEntry = {
  percent: number;
  source: "USER" | "PROGRAM" | "NONE";
};

type SendFeeInfoResponse = {
  result: boolean;
  fees: Record<string, SendFeeInfoEntry>;
};

export const feesApi = createApi({
  reducerPath: "feesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseHref,
    credentials: "include",
  }),
  endpoints: (builder) => ({
    assetFees: builder.query<AssetFeesResponse, { asset: string }>({
      query: (query) => `fees?${new URLSearchParams(query).toString()}`,
    }),
    sendFeeInfo: builder.query<SendFeeInfoResponse, void>({
      query: () => `withdrawal-estimation/fee-info`,
    }),
  }),
});

export const { useAssetFeesQuery, useSendFeeInfoQuery } = feesApi;
